import { Routes } from '@angular/router';
import { permisoGuard } from '../core/auth/permiso.guard';
import { Permiso } from '../core/auth/permisos';

export const usuariosRoutes: Routes = [
  {
    path: 'usuarios',
    canActivate: [permisoGuard],
    data: { permiso: [Permiso.USUARIOS_VER, Permiso.USUARIOS_REGIONAL] },
    loadComponent: () => import('./pages/usuarios/usuarios.page').then((m) => m.UsuariosPage),
    title: 'SiLabVet | Usuarios',
  },
];
